import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import classNames from "classnames";
import { usePage } from "@inertiajs/inertia-react";
import { Portal } from "@mui/base/Portal";

import { Trans } from "../../utils/i18n";
import { ImagePlaceholder } from "../../Shared/ImagePlaceholder";
import { useMediaQuery } from "@material-ui/core";

export function DeviceWidgetB2B({
    form,
    values,
    configurationProduct,
    products = [],
    onDelete = () => {},
    className,
    portalClassName,
    disablePortal = true,
    portalContainerId,
}) {
    const { requesttypes = [] } = usePage().props;
    const canPortalBeEnabled = useMediaQuery('(min-width:2000px)');
    const isPortalEnabled = !disablePortal && canPortalBeEnabled;

    return (
        <Portal
            disablePortal={!isPortalEnabled}
            container={() => document.getElementById(portalContainerId)}
        >
            <div
                className={classNames(
                    "p-4 rounded-md border border-gray-200",
                    isPortalEnabled && "absolute z-10",
                    isPortalEnabled && portalClassName,
                    className
                )}
            >
                <h3 className="m-0 pb-2">
                    <Trans i18nKey="common.products">Products</Trans>
                </h3>
                <ul
                    role="list"
                    className="divide-y divide-gray-100 m-0 p-0 list-none max-h-[400px] overflow-auto"
                >
                    {[configurationProduct, ...products]
                        .filter(Boolean)
                        .map((product) => (
                            <li
                                className="flex items-center justify-between gap-x-6 py-4 max-w-full"
                                key={product.id}
                            >
                                {product?.image ||
                                product?.productcategory?.image ? (
                                    <img
                                        className="hidden sm:block size-12 object-contain shrink-0 rounded-full bg-gray-50"
                                        src={product?.image || product?.productcategory?.image}
                                        alt=""
                                    />
                                ) : (
                                    <div className="hidden sm:flex items-center justify-center overflow-hidden size-12 shrink-0 rounded-full bg-gray-300">
                                        <ImagePlaceholder className="!size-10" />
                                    </div>
                                )}

                                <div className="flex-1 min-w-0 space-y-2">
                                    <div className="min-w-0 flex justify-start gap-3">
                                        <p className="m-0 font-semibold truncate text-gray-900">
                                            {product.description}
                                        </p>
                                        {product.warranty === true ? (
                                            <p className="leading-normal w-fit m-0 rounded-md whitespace-nowrap p-1 text-xs font-medium ring-1 ring-inset text-green-700 bg-green-50 ring-green-600/20">
                                                <Trans i18nKey="warrantyCheck.inWarranty">
                                                    In Warranty
                                                </Trans>
                                            </p>
                                        ) : product.warranty === false ? (
                                            <p className="leading-normal w-fit m-0 rounded-md whitespace-nowrap p-1 text-xs font-medium ring-1 ring-inset text-red-700 bg-red-50 ring-red-600/20">
                                                <Trans i18nKey="warrantyCheck.outOfWarranty">
                                                    Out of Warranty
                                                </Trans>
                                            </p>
                                        ) : null}
                                    </div>
                                    <div>
                                        {(product?.serialnumber ||
                                            product?.requesttype) && (
                                            <div class="flex flex-wrap items-center gap-2 text-sm text-gray-500">
                                                {product?.serialnumber && (
                                                    <p class="m-0 whitespace-nowrap">
                                                        {product?.serialnumber}
                                                    </p>
                                                )}
                                                {product?.serialnumber &&
                                                    product?.requesttype && (
                                                        <svg
                                                            viewBox="0 0 2 2"
                                                            class="size-0.5 fill-current"
                                                        >
                                                            <circle
                                                                cx="1"
                                                                cy="1"
                                                                r="1"
                                                            />
                                                        </svg>
                                                    )}
                                                {product?.requesttype && (
                                                    <p class="m-0 truncate">
                                                        {requesttypes?.find(
                                                            (type) =>
                                                                type.key ===
                                                                product.requesttype
                                                        )?.name ||
                                                            product?.requesttype}
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {product.id !== configurationProduct?.id && (
                                    <div className="shrink-0 flex items-center">
                                        <IconButton
                                            aria-label={
                                                <Trans i18nKey="common.remove">
                                                    Remove
                                                </Trans>
                                            }
                                            size="small"
                                            onClick={() => onDelete?.(product)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </div>
                                )}
                            </li>
                        ))}
                </ul>
            </div>
        </Portal>
    );
}
